<template>
    <page
        :id="state_identifier"
        title="Firms"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title><span></span></template>

        <div class="uk-margin-large-top">
            <data-table
                id="firms"
                :columns="visible_columns"
                :rows="filtered_rows"
                :search="state.search"
                :total="state.total"
                :found="state.found"
                :current-page="state.page"
                :total-pages="nb_pages"
                :searchable="false"
                table-class="lam-records-list"
                empty-title="No firms found"
                :export-entity="entity"
                :export-query="state"
                :export-fields="export_fields"
                @sort="sort_by"
                @search="search"
                @page="goto_page"
                @click="record_edit(entity, $event.id)"
            >
                <template v-slot:controls>
                    <form v-if="!!raw_firm_types&&!!raw_firm_types.length" @submit.prevent.stop class="uk-form">
                        <select @change="filter('firm_type', $event.target.value)">
                            <option value="" :selected="!state.filter">(Any firm type)</option>
                            <option
                                v-for="firm_type in firm_types"
                                :key="firm_type"
                                :value="firm_type"
                                :selected="state.filter === firm_type"
                            >
                                {{ firm_type }}
                            </option>
                        </select>
                    </form>
                </template>
                <template
                    v-slot:summary="{ row }"
                >
                    <h6>{{ row.name }} ({{ row.initials }})</h6>
                </template>
                <template
                    v-slot:tbody="{ row, field }"
                >
                    <router-link
                        v-if="field === 'name'"
                        :to="{ name: 'firm.edit', params: { id: row.id } }"
                    >
                        {{ row.name }}
                    </router-link>
                    <span v-else-if="field.match(/^nb_/)">{{ row[field] | nibnut.number("0,0") }}</span>
                    <span v-else-if="field.match(/_billings/)">$ {{ row[field] | nibnut.number("0,0.00") }}</span>
                    <span v-else>{{ row[field] }}</span>
                </template>
            </data-table>
        </div>
    </page>
</template>

<script type="text/javascript">
import is_records_list_page from "../../mixins/IsRecordsListPage"
import uses_color_palette from "../../mixins/UsesColorPalette"

export default {
    mixins: [is_records_list_page, uses_color_palette],
    mounted () {
        this.$store.dispatch("AUTOSUGGEST", { context: "firm_type" }).then(records => {
            this.raw_firm_types = records
        }).catch(error => {
            this.$error(error.message)
        })
    },
    computed: {
        firm_types () {
            // eslint-disable-next-line
            return this.raw_firm_types.sort()
        },
        export_fields () {
            return [
                "id", "name", "firm_type", "city_state", "nb_projects", "nb_prospective_projects", "nb_completed_projects",
                "total_billings_last_year", "total_billings"
            ]
        }
    },
    data () {
        return {
            entity: "firm",
            columns: {
                name: { label: "Name", sort: null, type: "plain", cell_class: "lam-col-name" },
                firm_type: { label: "Type", sort: null, type: "plain" },
                city_state: { label: "Location", sort: null, type: "plain" },
                nb_projects: { label: "# Projects", sort: null },
                nb_prospective_projects: { label: "Prospective Projects", sort: null, type: "plain" },
                nb_completed_projects: { label: "Completed Projects", sort: null, type: "plain" },
                total_billings_last_year: { label: "Billings (Last Year)", sort: null, type: "plain" },
                total_billings: { label: "Billings (This Year)", sort: null, type: "plain" }
            },
            default_state: {
                per_page: 30,
                page: 1,
                sort_by: "name",
                sort_dir: "asc",
                filter_on: "firm_type",
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0
            },

            raw_firm_types: []
        }
    }
}
</script>
